import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { PurchaseOrderActivity } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0670. 発注案件アクティビティ一覧
 * [GET] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_activities
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
};
const purchaseOrderActivities = (props: Props): Promise<PurchaseOrderActivity[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.id}/purchase_order_activities`);
};

export const usePurchaseOrderActivities = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => purchaseOrderActivities(props),
  });
};

export const usePurchaseOrderActivitiesInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'teams', props.team_id, 'purchase_orders', props.id, 'purchase_order_activities'];
};
